$(document).ready(() => {
  const $searchIcon = $(
    '<div ' +
      'id="placeholder-search-icon" ' +
      'class="v2-inline-block v2-text-light-400">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" stroke="currentColor" style="overflow: visible">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" stroke-width="0.2" d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29589 11.5892 8.49583 10.8906 9.47668L15.7071 14.2929L15.7903 14.3871C16.0953 14.7794 16.0676 15.3466 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47668 10.8906C8.49583 11.5892 7.29589 12 6 12C2.68629 12 0 9.31371 0 6ZM10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6Z\n"/>' +
      '</svg>' +
      '</div>'
  );

  const $s2PropertySearchInput = $('#property-search-input');
  const $buyButton = $('#propertySearchBuyButton');
  const $rentButton = $('#propertySearchRentButton');
  const $searchButton = $('#property-search-button');

  $buyButton.on('click', { selected: 'Sale' }, toggleActive);
  $rentButton.on('click', { selected: 'Rental' }, toggleActive);
  $searchButton.on('click', propertySearchSubmit);

  let buyOrRentQueryParam = 'Sale';

  function propertySearchSubmit() {
    const $data = $s2PropertySearchInput.select2('data');

    const suburbParams = $.param({
      suburbs: $data?.map((o) => o?.text ?? '')
    });

    const saleOrRentalQuery = `saleOrRental=${buyOrRentQueryParam}`;
    const suburbsQuery = suburbParams ? `&${suburbParams}` : '';
    const sortQuery = `&sortby=dateListed-desc`;

    window.location.href = `/listings?${saleOrRentalQuery}${sortQuery}${suburbsQuery}`;
  }

  function toggleActive(event) {
    buyOrRentQueryParam = event.data.selected;
  }

  $(function () {
    $s2PropertySearchInput.select2({
      placeholder: `Select...`,
      multiple: true,
      dropdownParent: $('#property-search-input-wrapper')
    });

    $('.select2-selection.select2-selection--multiple').prepend($searchIcon);
  });
});
